import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DiscordOutlinedSvg from "@ant-design/icons-svg/es/asn/DiscordOutlined";
import AntdIcon from '../components/AntdIcon';
var DiscordOutlined = function DiscordOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: DiscordOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(DiscordOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'DiscordOutlined';
}
export default RefIcon;